import styled from "styled-components";

import { Colors } from "../../../config";

import { FontStyles } from "../../../components";
const Container = styled.div(() => {
  return {
    position: "relative",
    display: "flex",
    width: "100%",
    backgroundColor: Colors.black,
    alignItems: "center",
    justifyContent: "center",
    paddingBlock: "clamp(9px, 7vw, 16px)",
    zIndex: 1,
    height: "min-content",

    boxShadow: "0px 10px 20px #00000006",
  };
});

const PeriodText = styled.p(({ theme }) => {
  const { palette: colors, spacing } = theme;
  return {
    margin: 0,
    ...FontStyles.semibold16,
    color: "white",
  };
});

const Styles = {
  Container,

  PeriodText,
};

export default Styles;
